import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuSliderOptions} from '@Components/contextual-menu/components/contextual-menu-slider-options';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromBorderOfActiveItem} from '@Hooks/poster-editor/useGetKeyFromBorderOfActiveItem';

const VECTOR_THICKNESS_MIN = 0;
const VECTOR_THICKNESS_MAX = 100;

interface VectorThicknessOptionProps {
  min?: number;
  className?: string;
  max?:number
}

export function VectorThicknessOption({className = '', min = VECTOR_THICKNESS_MIN, max = VECTOR_THICKNESS_MAX}: VectorThicknessOptionProps): ReactElement<any> | null {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeItemBorderThickness = useGetKeyFromBorderOfActiveItem('solidBorderThickness');

  if (!activeItem || activeItemBorderThickness === undefined) {
    return null;
  }

  const updateThickness = (solidBorderThickness: number, undoable = true): void => {
    activeItem.border.updateBorderThickness(solidBorderThickness, undoable);
  };

  const onChangeThickness = (updatedValue: number): void => {
    updateThickness(updatedValue, false);
  };

  const onChangeEnded = (updatedValue: number): void => {
    updateThickness(updatedValue);
  };

  return (
    <ContextualMenuSliderOptions
      className={className}
      id="sticker-thickness-option"
      value={activeItemBorderThickness}
      label={window.i18next.t('pmwjs_thickness')}
      range={{
        min,
        max,
      }}
      transformDisplay={{
        min,
        max: VECTOR_THICKNESS_MAX,
      }}
      onChange={onChangeThickness}
      onChangeEnded={onChangeEnded}
      addDelayToOnChange={activeItem.isVector() && activeItem.hasMultiplePaths()}
    />
  );
}
